export type LanguageSupportLevel = 'full' | 'partial'

export type SupportedLanguage = {
  value: string
  locale: string
  labelKey: string
  supportLevel: LanguageSupportLevel
  aliases?: string[]
}

export const supportedLanguages = [
  { value: 'english', locale: 'en', labelKey: 'dweb_common_language_english', supportLevel: 'full' },
  { value: 'arabic', locale: 'ar', labelKey: 'dweb_common_language_arabic', supportLevel: 'partial' },
  { value: 'amharic', locale: 'am', labelKey: 'dweb_common_language_amharic', supportLevel: 'partial' },
  { value: 'chinese', locale: 'zh', labelKey: 'dweb_common_language_chinese', supportLevel: 'partial' },
  { value: 'french', locale: 'fr', labelKey: 'dweb_common_language_french', supportLevel: 'partial' },
  { value: 'hindi', locale: 'hi', labelKey: 'dweb_common_language_hindi', supportLevel: 'partial' },
  { value: 'japanese', locale: 'ja', labelKey: 'dweb_common_language_japanese', supportLevel: 'partial' },
  { value: 'korean', locale: 'ko', labelKey: 'dweb_common_language_korean', supportLevel: 'partial' },
  { value: 'oromo', locale: 'om', labelKey: 'dweb_common_language_oromo', supportLevel: 'partial' },
  { value: 'russian', locale: 'ru', labelKey: 'dweb_common_language_russian', supportLevel: 'partial' },
  { value: 'spanish', locale: 'es', labelKey: 'dweb_common_language_spanish', supportLevel: 'full' },
  { value: 'somali', locale: 'so', labelKey: 'dweb_common_language_somali', supportLevel: 'partial' },
  { value: 'tagalog', locale: 'tl', labelKey: 'dweb_common_language_tagalog', supportLevel: 'partial' },
  { value: 'tigrigna', locale: 'ti', labelKey: 'dweb_common_language_tigrigna', supportLevel: 'partial' },
  { value: 'turkish', locale: 'tr', labelKey: 'dweb_common_language_turkish', supportLevel: 'partial' },
  {
    value: 'ukranian',
    locale: 'uk',
    labelKey: 'dweb_common_language_ukrainian',
    supportLevel: 'partial',
    aliases: ['ukrainian'],
  },
  { value: 'vietnamese', locale: 'vi', labelKey: 'dweb_common_language_vietnamese', supportLevel: 'partial' },
] as const satisfies readonly SupportedLanguage[]

const registeredLanguages: readonly SupportedLanguage[] = supportedLanguages

export const fullySupportedLanguages = supportedLanguages.filter((language) => language.supportLevel === 'full')

export const partiallySupportedLanguages = supportedLanguages.filter((language) => language.supportLevel === 'partial')

export const languagePreferenceLocales = registeredLanguages.reduce<Record<string, string>>((locales, language) => {
  locales[language.value] = language.locale
  language.aliases?.forEach((alias) => {
    locales[alias] = language.locale
  })
  return locales
}, {})

export function getLocaleFromLanguagePreference(languagePreference?: string) {
  if (!languagePreference) return 'en'

  return languagePreferenceLocales[languagePreference.toLowerCase()] || 'en'
}

export function getSupportedLanguage(languagePreference?: string) {
  if (!languagePreference) return undefined

  const normalizedLanguagePreference = languagePreference.toLowerCase()
  return registeredLanguages.find(
    (language) =>
      language.value === normalizedLanguagePreference || language.aliases?.includes(normalizedLanguagePreference)
  )
}
